import data from './data.json'

const { destaquePorPlano } = data

export const getDestaquePlano = codigoPlano => {
  if (!codigoPlano) {
    return destaquePorPlano.DEFAULT
  }

  const key = String(codigoPlano).toUpperCase()
  return destaquePorPlano[key] || destaquePorPlano.DEFAULT
}

export default getDestaquePlano
